import { useTranslation } from 'react-i18next'
import { Package } from 'lucide-react'

export function AddToProductEmptyMid() {
  const { t } = useTranslation()
  return (
    <main className="flex-1 flex flex-col items-center justify-center text-center bg-neutral-50 dark:bg-neutral-950 px-8">
      <Package className="w-12 h-12 text-neutral-300 dark:text-neutral-700 mb-3" />
      <h3 className="text-base font-semibold text-neutral-700 dark:text-neutral-300">
        {t('addToProduct.midPlaceholder.noProductTitle')}
      </h3>
      <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1 max-w-md">
        {t('addToProduct.midPlaceholder.noProductBody')}
      </p>
    </main>
  )
}
